"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var Observable_1 = require("rxjs/Observable");
var ProcessImportExportService = /** @class */ (function () {
    function ProcessImportExportService(http, applicationPropertiesService) {
        this.http = http;
        this.applicationPropertiesService = applicationPropertiesService;
        this.$url = Observable_1.Observable.from(this.applicationPropertiesService.getProperty('workflow-service-url'));
    }
    ProcessImportExportService.prototype.importProcess = function (processId, note, file) {
        var _this = this;
        var params = new FormData();
        params.append('note', note);
        params.append('file', file, file.name);
        return this.$url.flatMap(function (url) {
            return _this.http.post(url + '/processes/' + processId + '/import', params).map(function (res) {
                return res;
            });
        });
    };
    ProcessImportExportService.prototype.exportProcess = function (processId, note) {
        var _this = this;
        var params = {
            note: note
        };
        return this.$url.flatMap(function (url) {
            return _this.http.post(url + '/processes/' + processId + '/export', params).map(function (res) {
                return res;
            });
        });
    };
    ProcessImportExportService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    ProcessImportExportService.ctorParameters = function () { return [
        { type: idm_authentication_client_js_1.HttpClientWrapper, },
        { type: idm_application_properties_service_client_js_1.ApplicationPropertiesService, },
    ]; };
    return ProcessImportExportService;
}());
exports.ProcessImportExportService = ProcessImportExportService;
//# sourceMappingURL=process-import-export.service.js.map